import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['viewedLabel']

  initialize () {
    this._onPageshow = this.handlePageshow.bind(this)
  }

  connect () {
    this.updateViewedLabel()
    window.addEventListener('pageshow', this._onPageshow)
  }

  disconnect () {
    window.removeEventListener('pageshow', this._onPageshow)
  }

  handlePageshow () {
    this.updateViewedLabel()
  }

  className () {
    return this.element.dataset.classname
  }

  facilityId () {
    return this.element.dataset.facilityid
  }

  isViewedFacility (id) {
    const TTL = 90 * 24 * 60 * 60 * 1000 // 90 days
    try {
      const data = JSON.parse(localStorage.getItem('cs.readFacilities') || '{}')
      const now = Date.now()
      return data[id] && (now - data[id] < TTL)
    } catch (e) {
      return false
    }
  }

  updateViewedLabel () {
    if (!this.hasViewedLabelTarget) return
    if (this.isViewedFacility(this.facilityId())) {
      this.viewedLabelTarget.classList.remove(`${this.className()}::hidden`)
    } else {
      this.viewedLabelTarget.classList.add(`${this.className()}::hidden`)
    }
  }
}
